<template><div><h1 id="publikationen-zeitschriften" tabindex="-1"><a class="header-anchor" href="#publikationen-zeitschriften"><span>Publikationen, Zeitschriften</span></a></h1>
<p>Publikationen, Zeitschriften — Steuerung der Publikationsberechtigungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Jeder Zusage können im System automatisch eine oder mehrere Publikationen (Informationsschriften, Mitgliederzeitung etc.) zugeordnet werden. Diese Tabelle dient der Steuerung der Publikationsberechtigungen. Sie funktioniert wie ein Filter, der kontrolliert, ob eine Person den angegebenen Kriterien entspricht. Ist dies der Fall, erhält die Person die entsprechende Publikation automatisch zugeteilt. Die Publikationen können in Selektionen als Filterposition für den Versand eingegeben werden. Eine Publikation ist entweder fix mit einer Zusage verknüpft, oder es ist grundsätzlich jede Adresse berechtigt. Die Publikationsberechtigung wird online überprüft.</p>
<p>Die automatische Zuteilung der Publikationen erfolgt jedoch nur, wenn in den Publikationspositionen Kriterien für die Zuordnung definiert ist. Ansonsten betrifft der Wert im Feld &quot;Anzahl&quot; nur die manuell hinzugefügten Publikationen.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Publikationen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Publikation</dt>
<dd>Bezeichnung der Publikation</dd>
<dt>Beschreibung</dt>
<dd>Eine längere Beschreibung der Publikation</dd>
<dt>Zusage</dt>
<dd>Die Publikation ist nur mit einer aktiven Zusage gültig. Wird dieses Feld leer gelassen, kann die Publikation auch für Nicht-Zusager erfasst werden.</dd>
<dt>Anzahl</dt>
<dd>Anzahl Personen mit dieser Publikation. Diese Information wird periodisch ausgewertet und für grobe Auflagenschätzungen hier zur Verfügung gestellt.</dd>
<dt>aktualisiert am</dt>
<dd>Anzeige der letzten Aktualisierung des Feldes [Anzahl]</dd>
<dt>Kanäle</dt>
<dd>Mögliche Kanäle für die Publikation.</dd>
<dt>Attribute</dt>
<dd>Zu Publikationen können Attribute zugeordnet werden. Die Attribute werden zur Synchronisationssteuerung mit externen Schnittstellen verwendet:
<table>
<thead>
<tr>
<th>Attribut</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Eloqua</td>
<td>Publikation wird über die Eloqua-Schnittstelle synchroniosiert</td>
</tr>
<tr>
<td>AC</td>
<td>Publikation wird über die ActiveCampaign-Schnittstelle synchroniosiert</td>
</tr>
<tr>
<td>UniqEmail</td>
<td>Regel für &quot;Unique E-Mail&quot; freigeschaltet bei der Synchronisation mit externen Systemen:Es wird sichergestellt, dass bei der Erfassung von Publikationen die gleiche E-Mailadresse nicht von verschiedenen Personen verwendet werden können.Wenn z.B. bei Person 1000 eine Publikation «News A» mit E-Mail-Adresse «m.durtschi@email.ch» erfasst ist, kann bei der Person 1001 NICHT auch eine Publikation «News A» oder «News B» mit der gleichen E-Mail-Adresse «m.durtschi@email.ch» erfasst werden. Vorausgesetzt beide Publikationen haben das Attribut &quot;UniqueEmail&quot;.Mehrfacherfassung Publikation mit verschiedenen E-Mailadressen:Bei Person 1000 kann eine Publikation «News A» mit E-Mail-Adresse «m.durtschi@email.ch» und eine Publikation «News A» mit E-Mail-Adresse «md@bluewin.ch» erfasst werden.</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<p>Z.B. Attribut &quot;Eloqua&quot; für den Abgleich mit einem externen System beispielsweise Eloqua. In diesem Fall werden nur Publikationen abgeglichen die das Attribut &quot;Eloqua&quot; zugeordnet haben.</p>
<h2 id="publikationspositionen" tabindex="-1"><a class="header-anchor" href="#publikationspositionen"><span>Publikationspositionen</span></a></h2>
<dl>
<dt>Publikation</dt>
<dd>Bezeichnung der Publikation</dd>
<dt>Sprache</dt>
<dd>Sprache, aus Tabelle &quot;Sprachen&quot;, dient der sprachabhängigen Steuerung der Publikation. Beispiel: Wird lediglich ein Verteilungssatz mit Sprache &quot;d&quot; erfasst, erhalten die Personen mit Sprache &quot;f&quot; oder &quot;i&quot; diese Publikation nicht!</dd>
<dt>ab Alter</dt>
<dd>Eingrenzung nach Jahrgang. Gewählt wird die Person, die im aktuellen Jahr das Alter erreicht oder bereits älter ist. Personen ohne Geburtsjahr gelten als gewählt.</dd>
<dt>bis Alter</dt>
<dd>Eingrenzung nach Jahrgang. Gewählt wird eine Person, wenn diese nicht älter ist oder im aktuellen Jahr nicht älter wird. Personen ohne Geburtsjahr werden nicht gewählt.</dd>
<dt>Z</dt>
<dd>Z = Zusager. Statusinformation der Person als Kriterium zur Einschränkung der allgemeinen Gültigkeit einer Publikation.</dd>
<dt>S</dt>
<dd>S = Spender. Statusinformation der Person als Kriterium zur Einschränkung der allgemeinen Gültigkeit einer Publikation.</dd>
<dt>K</dt>
<dd>K = Käufer. Statusinformation der Person als Kriterium zur Einschränkung der allgemeinen Gültigkeit einer Publikation.</dd>
<dt>nur Inland</dt>
<dd>Inländische Adresse als Einschränkungskriterium.</dd>
<dt>Filter</dt>
<dd>Angabe eines Filters als Einschränkung. Die entsprechenden Filter sollten nicht markiert sein (Online Filter).</dd>
<dt>Filterbeschreibung</dt>
<dd>Beschreibung des ausgewählten Filters.</dd>
<dt>Steuerung</dt>
<dd>Definiert, ob die Publikation verfügbar ist, oder bereits abonniert ist.</dd>
<dt>Zusage</dt>
<dd>Angabe einer Zusage als Einschränkungskriterium.</dd>
<dt>Zusagentyp</dt>
<dd>Angabe des Zusagetyps zur Zusage als Einschränkungskriterium.</dd>
</dl>
</div></template>


